import { render } from "./check-tgl-pegawai-import.vue?vue&type=template&id=620427bc"
import script from "./check-tgl-pegawai-import.vue?vue&type=script&lang=js"
export * from "./check-tgl-pegawai-import.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__